import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=2dbe1312&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=js&"
export * from "./AddressList.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=2dbe1312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe1312",
  null
  
)

export default component.exports